import type { FaireProductEntity } from "../../entity_types/product";

export const p_hyc3pw7ypx: FaireProductEntity = {
  token: "p_hyc3pw7ypx",
  type: "product",
  name: "Lucie Floral Cotton Muslin Blanket",
  brandToken: "b_6gjfy9yksc",
  brandName: "Helmsie",
  imageUrl:
    "https://cdn.faire.com/fastly/7d030b495b006d8169dade9186228215374fd6e6c1de05a1afb93b8d0af633fe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/29168bb4acf847fc7430c9f6d0f03dd69f2037b93ed03f10c4c43be572c0718e.jpeg",
    "https://cdn.faire.com/fastly/fe6cbf8c78ca544a8e6cf06aef738cf340cef174fe4aa629e983a40c01997c3f.png",
    "https://cdn.faire.com/fastly/b3aca384cd1adcb2d7ed3ea9e7c5fa5fd15e7932dd8becad6a7559f4b390c061.jpeg",
    "https://cdn.faire.com/fastly/794c38be63451a061840e48870df00d879d4f17a85a4267f0b67b1477e4c7cf6.jpeg",
    "https://cdn.faire.com/fastly/f6ba681c8cc4c2dafd055b65d14158dc6dbc4635581619487e4c5c0cae4cd4b2.jpeg",
  ],
  priceDollars: 22,
  description:
    "Soft, sweet, and beautifully timeless — this four-layer cotton muslin blanket is designed to bring comfort and charm wherever you go. The hand-drawn floral pattern blooms in a perfectly muted palette, surrounded by a hand-dyed cotton velvet trim that adds an elegant touch of texture and warmth.\n\nSized at 30x30 inches, it’s light and breathable, ideal for snuggling, soothing, or tucking into your tote or diaper bag for adventures out the door. It’s that special “lovey” size your little one will adore — perfect for the car, stroller, or cozy naps at home.\n\nEach wash only makes it softer, ensuring this blanket becomes a cherished favorite for years to come.\n\nSize: 30in x 30in\n\nMade in India\n",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:59.996Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
